namespace Matrix.Navigation {
    export namespace FullTextSearchService {
        export const baseUrl = 'FullTextSearch';

        export declare function Search(request: FullTextSearchRequest, onSuccess?: (response: Serenity.ListResponse<FullTextSearchResult>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Search = "FullTextSearch/Search"
        }

        [
            'Search'
        ].forEach(x => {
            (<any>FullTextSearchService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
